var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Check_svg__a",
    d: "M9.658 14.817l-3.475-3.475L5 12.517l4.658 4.658 10-10L18.483 6z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#017ACD",
    fillRule: "nonzero",
    xlinkHref: "#Check_svg__a"
  })));
};
export default SvgCheck;